<template>
<!--  o jest widok dla realizacji zamówień pakietowych. Jeśli ma uzupelniony groupGuid - to wyswietla tylko zamówienia z zakresu danego group guida (to widok dla centrali)-->
<!--  Czyli mamy to dwa stany:-->
<!--  1. centralna instancja aplikacji - wtedy musi być podany groupGuid - i wtedy widzimy zamówienia tylko z tego group guida-->
<!--  2. lokalna instancja aplikacji - wtedy nie ma group guida i widzimy wszystkie zamówienia-->
  <div>
    <div class="row">
      <div v-if="!isViewValid" class="alert alert-danger">
        <h4 class="alert-heading">Widok niedostępny!</h4>
        <p>Nie podano grupowego identyfikatora zamówienia, który jest wymagany dla centralnej instancji aplikacji.</p>
        <hr>
      </div>
      <div v-else :class="generatorTableSectionClass">
        <!-- Buttons for local instance -->
        <div v-if="!commonModule.centralInstance" style="clear: both; margin-bottom: 5px; display: block;padding-right: unset;">
          <div style="float: right; margin-right: 2px; z-index: 0;padding-right: unset;">
            <button
                type="submit"
                id="refresh-order-details-btn"
                @click="downloadOrders()"
                class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
            >
              <i class="bx bx-cloud-download align-middle font-size-16"/>
              Pobierz zamówienia centralne
            </button>

          </div>
        </div>



        <div v-if="orderGroupGuid != null" class="row">
          <FloationgBackButton @backAction="goBack()"/>
        </div>


        <div class="package-orders-table-container">
          <SearchBar2
              :searchOptions="fieldsAvailableForSearch"
              @searchRequest="searchOnList($event)"
          />

          <CommonDataPanel :key="dataPanelData" :data="dataPanelData" :headers="dataPanelHeaders"
                           :maxGridColumns="2"
                           :allowGridItemWidth="true"
                           titleKey="orderName"
                           @onTriggerAction="runAction($event)"
          />


          <CommonTable2
              :table="tableData"
              rowIdentifier="guid"
              @onItemAction="runAction($event)"
              @onSort="sort($event)"
              @onMassAction="runMassAction($event)"
              @onCheckItem="checkAction($event)"
              :key="refreshTable"
              :currentPage="currentPage"
              :totalRows="packagesModule.getPackageOrdersTotal"
              :totalPages="packagesModule.getPackageOrdersPagesCount"
              :showPaginationTop="true"
              :showPaginationBottom="true"
              :multiselect="true"
              @onPageChange="currentPage = $event"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
              :showMassActions="true"
              :showRowActions="true"
              :initiallyCheckedItemsData="selectedItems"
              :enableRowSelection="false"
              :showCheckboxColumn="false"
          />
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import SearchBar2 from "@/components/widgets/SearchBar2.vue";
import FloationgBackButton from "@/components/widgets/FloatingBackButton.vue";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {log} from "@/state/pinia/log";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {commonAppHelperMethods} from "@/views/DrugstoreCommonManager/helper/commonAppHelperMethods";
import {useLayoutStore} from "@/state/pinia/layout";
import CommonDataPanel from "@/components/widgets/CommonDataPanel.vue";

export default {
  name: "PackagesManagerOrdersRealisationView",
  components: {
    CommonDataPanel,
    CommonTable2,
    SearchBar2,
    FloationgBackButton,
  },
  props: {
    orderGroupGuid: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      tableData: {},
      currentGroupOrder: null,
      packageOrders: [],
      selectedItems: [],
      selectedOrderName: null,
      sortingDirection: "DESC",
      sortingKey: "id",
      currentPage: 1,
      searchRequest: {
        searchPhrase: "",
        searchKey: "",
      },
      refreshTable: true,

      tableMassActions: [
      ],

      fieldsAvailableForSearch: [
        {
          name: "Nazwa zamówienia",
          key: "orderName", // Mapped to type 0
        },
        {
          name: "Nazwa pozycji",
          key: "itemName", // Mapped to type 1
        },
        {
          name: "Numer bloz pozycji",
          key: "itemBloz", // Mapped to type 2
        },
      ],

      availableHeaders: [
        {
          text: "ID",
          key: "id",
          type: "number",
          sortable: true,
          style: "width: 60px;text-align:left!important;",
        },
        {
          text: "Data",
          key: "orderCreationDate",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",
        },
        {
          text: "Symbol zamówienia",
          key: "orderReference",
          type: "text",
          sortable: true,
          style: "width: 140px;text-align:left!important;",
        },
        {
          text: "Apteka",
          key: "drugstore",
          type: "text",
          sortable: true,
          style: "width: 300px;text-align:left!important;",
        },

        {
          text: "Status zamówienia",
          key: "orderStatus",
          type: "text",
          sortable: true,
          style: "width: 50px;text-align:left!important;",
        },
        {
          text: "Stan realizacji",
          key: "realisationLevel",
          type: "progress",
          sortable: true,
        },
        {
          text: "Dostarczono",
          key: "deliveredAt",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          style: "width: 90px;text-align:left!important;",

        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          actions: [
            {
              text: "",
              icon: "fas fa-search",
              action: "view-details",
              enabled: true,
              tooltip: "Szczegóły",
              class: "btn btn-info btn-sm table-actions-button edit-button",
            },


          ],
        },
      ],

      dataPanelData: null,
      dataPanelHeaders: [
        {text: "Data zam.", key: "orderCreationDate", type: "date", isMeta: true},
        {text: "Symbol zamówienia", key: "orderReference", type: "text", isMeta: true},
        {
          text: "Dostawca",
          key: "supplierName",
          type: "text",
          isMeta: true
        },
        {
          text: "Status zamówienia",
          key: "describedStatus",
          type: "html",
          sortable: true,
          width: "300px"

        },
        {
          text: "Stan realizacji",
          key: "realisationLevel",
          type: "progress",
          sortable: true,
          width: "600px",
          style:{marginLeft:"48px"}
        },



      ]



    };
  },
  computed: {
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    isViewValid() {
      return (this.commonModule.centralInstance && this.orderGroupGuid != null && this.orderGroupGuid.length > 0) || (this.commonModule.centralInstance === false);
    },
    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },


    generatorTableSectionClass(){
      if(this.layout === 'horizontal'){
        return 'app-layout-table-conatiner';
      }else{
        return 'app-layout-table-conatiner-vertical';
      }
    },



  },
  methods: {
    downloadOrders() {
      this.packagesModule.httpDownloadOrdersFromCentral().then(() => {
        this.refreshPackageOrdersList();
      })
    },
    openOrdersGeneratorForm() {
      this.$router.push({name: 'PackagesManagerOrdersGeneratorStage', query: {}})
    },

    goBack() {
      this.$router.go(-1);
    },
    sort(sortKey) {
      if (this.sortingKey === sortKey) {
        this.toggleSortingDirection();
      } else {
        this.sortingKey = sortKey;
        // Default new sort to DESC for compatibility or ASC? Original toggles.
        this.sortingDirection = "ASC";
      }
      this.refreshPackageOrdersList();
    },
    toggleSortingDirection() {
      this.sortingDirection = this.sortingDirection === "ASC" ? "DESC" : "ASC";
    },
    checkAction(event) {
      // event.itemsData contains array of checked items identifiers
      this.selectedItems = event.itemsData;
    },
    searchOnList(searchRequest) {
      this.searchRequest = searchRequest;
      this.currentPage = 1;
      this.refreshPackageOrdersList();
    },
    runAction(event) {
      const action = event.action.action;
      const item = event.itemData;

      if (action === "view-details") {
        this.goToOrderDetails(item);
      }
    },
    runMassAction(event) {
      const action = event.action.action;
      const items = event.items; // Array of guids
      log.log("Running mass action: " + action);
      log.log(event);

    },
    goToOrderDetails(order) {
      console.log("Going to order details for order: " + order.guid);
      this.$router.push({name: 'PackagesManagerItemsStage', query: {orderGuid: order.guid}, params: {orderGuid: order.guid}});
    },

    getSearchTypeFromKey(key) {
      if (key === "orderName") return 0;
      if (key === "itemName") return 1;
      if (key === "itemBloz") return 2;
      return 0; // Default
    },
    refreshPackageOrdersList() {
      // Logic from original component
      if (this.orderGroupGuid) {
        this.commonModule.httpGetDrugstoresNameMap().then(() => {
          this.getPackagesOrdersForCentralInstanceForParticularGroup();
        })
      } else {
        this.getPackagesOrdersForLocalInstance();
      }
    },
    getPackagesOrdersForLocalInstance() {
      this.packagesModule.setPackageOrders([]);
      
      // Map SearchBar2 request to backend expected payload
      const searchPayload = {
        searchPhrase: this.searchRequest.searchPhrase || "",
        type: this.getSearchTypeFromKey(this.searchRequest.searchKey)
      };

      var requestPayload = {
        currentPage: this.currentPage,
        searchAndFilterRequest: searchPayload,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection
      };
      
      this.performFetch(requestPayload);
    },
    getPackagesOrdersForCentralInstanceForParticularGroup() {
      this.packagesModule.setPackageOrders([]);
      
       // Map SearchBar2 request to backend expected payload
      const searchPayload = {
        searchPhrase: this.searchRequest.searchPhrase || "",
        type: this.getSearchTypeFromKey(this.searchRequest.searchKey)
      };

      var requestPayload = {
        groupGuid: this.orderGroupGuid,
        currentPage: this.currentPage,
        searchAndFilterRequest: searchPayload,
        sortingKey: this.sortingKey,
        sortingDirection: this.sortingDirection
      };
      
      this.performFetch(requestPayload).then(() => {
         this.selectedOrderName = this.packagesModule.getPackageOrders.length > 0 ? this.packagesModule.getPackageOrders[0].orderName : "";
      });
    },
    performFetch(requestPayload) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      return this.packagesModule.httpGetPackageOrdersPaging(requestPayload).then(() => {
        this.packageOrders = JSON.parse(JSON.stringify(this.packagesModule.getPackageOrders));
        this.packagesModule.setOrdersChangesSeenState({});
        var ordersGuidsToGetChangesState = this.packageOrders.map((o) => o.guid);

        var childRequestPayload = {
          ordersGuids: ordersGuidsToGetChangesState,
        };
        // Background fetch extras
        this.packagesModule.httpGetOrderChangesSeenStatus(childRequestPayload);
        this.packagesModule.httpGetReportLastSentDatesForOrders(childRequestPayload);

        this.updateTableData();
        this.lazyloaderModule.setDisplayLazyLoader(false);
      }).catch(e => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
        console.error(e);
      });
    },
    updateTableData() {

      
      // Process data to match/transform columns if needed
      // e.g. actions
      this.packageOrders.forEach(order => {

        const drugstore = this.commonModule.getDrugstoresNameMap[order.drugstoreClientId] || `Nieznana apteka`;
        order["drugstore"] = ` [${order.drugstoreClientId}] ${drugstore}`;

        order.actions = [];
      });
      this.tableData["headers"] = this.availableHeaders;
      this.tableData["massActions"] = this.tableMassActions;
      this.tableData["data"] = this.packageOrders;
      this.refreshTable = !this.refreshTable; // Trigger re-render if needed
    }
  },
  watch: {
    currentPage() {
      this.refreshPackageOrdersList();
    },
  },
  mounted() {

    this.simplepharmAuth.refreshToken().then(()=>{
      if (this.orderGroupGuid) {
        this.packagesModule.httpGetPackageGroupOrderByGuid({orderGroupGuid: this.orderGroupGuid}).then((response) => {

          const fetchedOrder = response.data.payload
          const orderCreationDate = new Date(fetchedOrder.orderCreationDate).toLocaleString('sv', {timeZone: 'Europe/Warsaw'}).split(' ')[0]; // format yyyy-mm-dd
          this.currentGroupOrder = fetchedOrder
          this.currentGroupOrder.orderCreationDate = orderCreationDate;
          const orderStatusVal = this.currentGroupOrder.orderStatus ? this.currentGroupOrder.orderStatus.toLowerCase() : "unknown";
          const unknownStatus = {key:"unknown",text:"Status nieznany",description: "Nie rozpoznano statusu", icon: "fas fa-question-circle", color:"red"};
          const orderStatusInfo = this.packagesModule.getPackageOrderStatusMapWithDescription[orderStatusVal] || unknownStatus;

          this.currentGroupOrder["describedStatus"] = `<span  style="color:${orderStatusInfo.color}"><i class="${orderStatusInfo.icon}"></i> ${orderStatusInfo.text}</span>`;
          this.dataPanelData = this.currentGroupOrder;
          this.lazyloaderModule.setDisplayLazyLoader(false);
          console.log("Fetched order for details modal: ", this.currentGroupOrder);
        })
      }
      if (this.isViewValid) {
        this.refreshPackageOrdersList();
      }
    })


  }
};
</script>

<style scoped>
.package-orders-table-container {
    margin-top: 20px;
}


.app-layout-table-conatiner {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  position: fixed;
  left: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  max-height: 500vh; /* or any height you prefer */


}


.app-layout-table-conatiner-vertical {
  font-family: "Segoe UI", Tahoma, sans-serif;
  font-size: 13px;
  color: #2b2b2b;
  position: unset;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 500vh; /* or any height you prefer */


}
</style>
